import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import * as React from 'react';
import { StyleSheet } from 'aphrodite';
import xIcon from '@phosphor-icons/core/regular/x.svg';
import magnifyingGlassIcon from '@phosphor-icons/core/bold/magnifying-glass-bold.svg';
import { styles as styles$1 } from '@khanacademy/wonder-blocks-typography';
import { Id, View } from '@khanacademy/wonder-blocks-core';
import IconButton from '@khanacademy/wonder-blocks-icon-button';
import { TextField } from '@khanacademy/wonder-blocks-form';
import { PhosphorIcon } from '@khanacademy/wonder-blocks-icon';
import { semanticColor, border, spacing } from '@khanacademy/wonder-blocks-tokens';

const defaultLabels = {
  clearSearch: "Clear search"
};

const _excluded = ["clearAriaLabel", "autoFocus", "disabled", "id", "value", "placeholder", "style", "testId", "error", "instantValidation", "validate", "onValidate", "onClick", "onChange", "onFocus", "onBlur"];
const SearchField = React.forwardRef(function SearchField(props, ref) {
  const {
      clearAriaLabel = defaultLabels.clearSearch,
      autoFocus,
      disabled = false,
      id,
      value,
      placeholder,
      style,
      testId,
      error,
      instantValidation = true,
      validate,
      onValidate,
      onClick,
      onChange,
      onFocus,
      onBlur
    } = props,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  const innerRef = React.useRef(null);
  const handleClear = () => {
    var _innerRef$current;
    onChange("");
    innerRef == null || (_innerRef$current = innerRef.current) == null || _innerRef$current.focus();
  };
  const maybeRenderClearIconButton = () => {
    if (!value.length || disabled) {
      return null;
    }
    return React.createElement(IconButton, {
      icon: xIcon,
      size: "small",
      kind: "tertiary",
      actionType: "neutral",
      onClick: handleClear,
      style: styles.dismissIcon,
      "aria-label": clearAriaLabel
    });
  };
  return React.createElement(Id, {
    id: id
  }, uniqueId => React.createElement(View, {
    onClick: onClick,
    style: [styles.inputContainer, style]
  }, React.createElement(PhosphorIcon, {
    icon: magnifyingGlassIcon,
    size: "small",
    color: disabled ? semanticColor.icon.disabled : semanticColor.icon.primary,
    style: styles.searchIcon,
    "aria-hidden": "true"
  }), React.createElement(TextField, _extends({
    id: uniqueId,
    type: "text",
    autoFocus: autoFocus,
    disabled: disabled,
    instantValidation: instantValidation,
    validate: validate,
    onValidate: onValidate,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    placeholder: placeholder,
    error: error,
    ref: node => {
      if (ref) {
        ref.current = node;
      }
      innerRef.current = node;
    },
    value: value,
    style: [styles.inputStyleReset, styles$1.LabelMedium],
    testId: testId
  }, otherProps)), maybeRenderClearIconButton()));
});
const styles = StyleSheet.create({
  inputContainer: {
    boxSizing: "border-box",
    flexDirection: "row",
    borderRadius: border.radius.radius_040,
    alignItems: "center",
    height: 40
  },
  searchIcon: {
    marginLeft: spacing.xSmall_8,
    marginRight: spacing.xSmall_8,
    position: "absolute"
  },
  dismissIcon: {
    margin: 0,
    position: "absolute",
    right: spacing.xxxSmall_4
  },
  inputStyleReset: {
    display: "flex",
    flex: 1,
    width: "100%",
    paddingLeft: spacing.xLarge_32,
    paddingRight: spacing.large_24 + spacing.medium_16
  }
});

export { SearchField as default };
